import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddAccountFeeComp from "./Component/AddAccountFeeComp"


const AddAccountFee =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddAccountFeeComp />
        </div>
        <Footer />
        </>
    )
}

export default AddAccountFee